import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Catalog } from 'models/catalog';

@Component({
    selector: 'da-catalog-list',
    templateUrl: './catalog-list.component.html',
    styleUrls: ['./catalog-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CatalogListComponent implements OnInit {
    @Input() catalogs: Catalog[];
    constructor() {}

    ngOnInit() {}
}
